import { Injectable } from '@angular/core';
import { UserInfo } from '@app/core/models';
import { Observable } from 'rxjs';
import { UserInfoQuery } from './user-info.query';
import { UserInfoStore } from './user-info.store';


@Injectable({
	providedIn: 'root'
})
export class UserInfoService {
	constructor(
		private userInfoStore: UserInfoStore,
		private userInfoQuery: UserInfoQuery
	) { }

	addRoles(roles: string[]): void {
		this.userInfoStore.update(state => ({ ...state, roles: [...state.roles, ...roles] }));
	}

	updateInfo(userInfo: UserInfo): void {
		this.userInfoStore.update(userInfo);
	}

	getUserInfo$(): Observable<any> {
		return this.userInfoQuery.userInfo$;
	}
}
